<template>
	<div class="col-xs-12 npd block versiculo__slider">
		<div id="myCarousel" class="carousel slide" data-ride="carousel" data-interval="false">
			<div class="container">
				<div class="row">
					<div class="carousel-inner">


						<div class="item" v-for="versiculo in versiculos">
							<figure class="hidden-xs hidden-sm col-md-3" v-if="versiculo.better_featured_image!=null">
								<img v-bind:src="versiculo.better_featured_image.media_details.sizes['306x307'].source_url" alt="" class="shadow">
							</figure>
							<figure class="hidden-xs hidden-sm col-md-3" v-else>
								<img v-bind:src="theme_url+'/html/assets/img/versiculo.jpg'" alt="" class="shadow">
							</figure>
							<article class="col-xs-12 col-md-9 versiculo__des">
								<h3>Versículo del día</h3>
								<span v-html="versiculo.excerpt.rendered"></span>
								<p class="cita">{{ versiculo.title.rendered }}</p>
								<div class="compartir">
									<span>Compartir en</span>
									<ul>
										<li><a v-bind:href="'https://www.facebook.com/sharer/sharer.php?u='+versiculo.link" target="_blank"><i class="fa fa-facebook"></i></a></li>
										<li><a v-bind:href="'https://twitter.com/share?text='+versiculo.link" target="_blank"><i class="fa fa-twitter"></i></a></li>
										<li class="itemwa"><a v-bind:href="'whatsapp://send?text='+versiculo.soloexcerpt+' '+versiculo.title.rendered+' '+versiculo.link"><i class="fa fa-whatsapp"></i></a></li>
									</ul>
								</div>
							</article>
						</div>



					</div>
				</div>
			</div>

			<a class="left carousel-control" href="#myCarousel" data-slide="prev">
				<i class="fa fa-chevron-left"></i>
			</a>
			<a class="right carousel-control" href="#myCarousel" data-slide="next">
				<i class="fa fa-chevron-right"></i>
			</a>
		</div>
	</div>
</template>


<script>
export default {

	mounted: function() {
		const vm = this;
		vm.getVersiculos();

	},

	data() {
		return {
			versiculos: [],
			loaded: 'false',
			theme_url:rtwp.theme_url
		};
	},

	methods: {
		getVersiculos: function( ) {
			const vm = this;
			vm.$http.get( 'wp/v2/versiculo')
				.then( ( res ) => {
					vm.versiculos = res.data;
					vm.loaded = 'true';
					vm.$nextTick(function () {
						jQuery('.versiculo__slider div.item:first').addClass('active');
						init_attach();
					});
				} )
				.catch( ( res ) => {
					//console.log( `Something went wrong : ${ res }` );
				} );

			// vm.$nextTick(function () {
			// 	jQuery(window).load(function($) {
			// 		jQuery('.versiculo__slider div.item:first').addClass('active');
			// 	});
			// });

		},
	}
};
</script>



// WEBPACK FOOTER //
// versiculodeldia.vue?0407ee2a